
const FeaturesSection = () => {
  const features = [
    {
      image: "https://public.readdy.ai/ai/img_res/78f159f6b323f1452844140180184aba.jpg",
      title: "24/7 Expert Support",
      description: "Our dedicated IT professionals are available around the clock to resolve your technical issues and keep your operations running smoothly without interruption."
    },
    {
      image: "https://readdy.ai/api/search-image?query=advanced%20cybersecurity%20shield%20visualization%20with%20digital%20lock%20icons%20network%20protection%20layers%20glowing%20purple%20and%20blue%20security%20elements%20abstract%20technology%20background%20representing%20data%20protection&width=800&height=600&seq=feature-security-shield-002&orientation=landscape",
      title: "Enterprise-Grade Security",
      description: "Protect your business with military-grade encryption, multi-layer security protocols, and continuous threat monitoring to safeguard your valuable data assets."
    },
    {
      image: "https://readdy.ai/api/search-image?query=cloud%20computing%20infrastructure%20visualization%20with%20interconnected%20servers%20data%20flowing%20through%20networks%20purple%20gradient%20technology%20abstract%20modern%20cloud%20architecture%20scalable%20systems&width=800&height=600&seq=feature-cloud-infra-003&orientation=landscape",
      title: "Scalable Cloud Solutions",
      description: "Grow your business without infrastructure limitations. Our cloud services scale seamlessly with your needs, ensuring optimal performance at every stage."
    },
    {
      image: "https://readdy.ai/api/search-image?query=IT%20training%20session%20with%20instructor%20teaching%20professionals%20in%20modern%20classroom%20setting%20interactive%20learning%20environment%20technology%20education%20digital%20screens%20purple%20accent%20colors%20collaborative%20atmosphere&width=800&height=600&seq=feature-training-session-004&orientation=landscape",
      title: "Comprehensive IT Training",
      description: "Empower your team with expert-led training programs covering the latest technologies, security best practices, and productivity tools for maximum efficiency."
    }
  ];

  return (
    <section className="py-16 sm:py-24 bg-gradient-to-b from-slate-900 to-indigo-950">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="text-center mb-12 sm:mb-16">
          <div className="inline-block px-4 py-2 bg-violet-500/20 border border-violet-500/30 text-violet-300 text-xs sm:text-sm font-semibold rounded-full mb-4">
            Why Choose AZZ MATRIX
          </div>
          <h2 className="text-3xl sm:text-4xl lg:text-5xl font-bold text-white mb-4">Built for Modern Businesses</h2>
          <p className="text-base sm:text-lg text-gray-400 max-w-3xl mx-auto px-4">
            We combine cutting-edge technology with personalized service to deliver IT solutions that truly make a difference.
          </p>
        </div>

        <div className="grid grid-cols-1 lg:grid-cols-2 gap-6 sm:gap-8">
          {features.map((feature, index) => (
            <div 
              key={index}
              className="group bg-slate-800/50 backdrop-blur-sm border border-violet-500/20 rounded-2xl overflow-hidden hover:bg-slate-800 hover:border-violet-500/40 transition-all duration-300 hover:shadow-xl hover:shadow-violet-500/20"
            >
              <div className="w-full h-48 sm:h-64 overflow-hidden">
                <img 
                  src={feature.image}
                  alt={feature.title}
                  className="w-full h-full object-cover object-top group-hover:scale-110 transition-transform duration-500"
                />
              </div>
              <div className="p-6 sm:p-8">
                <h3 className="text-xl sm:text-2xl font-bold text-white mb-3 sm:mb-4 group-hover:text-violet-400 transition-colors">
                  {feature.title}
                </h3>
                <p className="text-sm sm:text-base text-gray-400 leading-relaxed">
                  {feature.description}
                </p>
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
};

export default FeaturesSection;
